import URLS from '@/server/urls';
import { GET } from '@/server/http';

export default async ({
    type = 0, // 0:全部 1:公开接口 2:受控接口 3:禁用接口
}, options = { showError: true }) => {
    const [ content, error, status ] = await GET(URLS.sysApi.getCateList, {
        type,
    }, options);
    if (error) return { error, status };
    return content || { rows: [] };
};
